export default __webpack_public_path__ + "static/haiku-haunted-hunt-f0c5739426a8ae4b782b788fc71c4f9d.svg";